module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "calibre_toc_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_006#_idTextAnchor020"
    }
  }, [_vm._v("Baking Pantry Essentials"), _c('span', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Dessi is the baker in the family, and I wanted to make sure she shared a bunch of her sweet recipes in this book. For the most part, Dessi’s recipes are paleo, and always gluten-free. Here are the pantry essentials you will need to stock up on to make her yummy desser"), _c('span', [_vm._v("t")]), _c('span'), _c('span', [_vm._v("recipes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_vm._v("100% Grass-Fed Ghee")]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-over-images"
  }, [_vm._v("Ghee is like butter, but even better! Make sure it’s 100% grass-fed. I don’t want any GMOs in your kitchen!")]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_vm._v("Butter")]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-over-images"
  }, [_vm._v("When it comes to butter, go for unsalted Kerrygold.")]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_vm._v("Baking Soda")]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-over-images"
  }, [_vm._v("Nothing fancy here. Any type will do.")]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "shopping-tip-blue"
  }, [_vm._v("Pure Vanilla Extract")])]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-over-images"
  }, [_vm._v("No imitation vanilla. The real deal!")]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "shopping-tip-blue"
  }, [_vm._v("Virgin Coconut Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-over-images"
  }, [_vm._v("Virgin coconut oil is a one-to-one replacement for any fat in sweet or savory recipes. Stick with unprocessed virgin oil.")]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "shopping-tip-blue"
  }, [_vm._v("Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-over-images"
  }, [_vm._v("Celtic Sea Salt® or Himalayan pink salt.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_42"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ca378f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_024.vue
// module id = 129
// module chunks = 0